import ConfirmWithPasswordModal from "@/components/confirm-with-password-modal";
import { Button } from "@/components/core/buttons/button";
import ComboboxCreatable from "@/components/core/forms/combox-creatable";
import { Form, FormField, FormGroup, FormItem, FormLabel } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { zodResolver } from "@hookform/resolvers/zod";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useEvidenceMutation } from "../api/queries/evidence-query";
import caseEvidenceCategoryService from "../api/services/category-service";
import caseEvidenceService from "../api/services/evidence-service";
import { type CaseEvidence, type CaseEvidenceForm, caseEvidenceFormSchema } from "../types/evidence";
import type { EvidenceRequirements } from "./case-evidence-edit-modal";

export default function CaseEvidenceAddCategoryModal({
	data,
	submarking,
	newSubmarking,
	selectedText,
	url,
	file,
	requiredEvidence,
	onSubmit,
	amend,
}: {
	data: CaseEvidence;
	submarking?: CaseEvidence;
	newSubmarking?: CaseEvidence;
	selectedText?: string;
	url?: string;
	file?: File;
	requiredEvidence?: EvidenceRequirements;
	onSubmit?: (values: CaseEvidenceForm) => void;
	amend?: boolean;
}) {
	const { closeModal } = useModalControl();
	const modal = useModal();
	const caseEvidenceMutation = useEvidenceMutation();

	const form = useForm<CaseEvidenceForm>({
		resolver: zodResolver(caseEvidenceFormSchema),
		defaultValues: {
			id: data?.id || submarking?.id || "",
			case_id: requiredEvidence?.case_id || data?.case_id || submarking?.case_id || newSubmarking?.case_id,
			parent_id: data?.id || submarking?.parent_id || submarking?.id || newSubmarking?.id,
			case_record_user_id: data?.case_record_user_id || submarking?.case_record_user_id || newSubmarking?.case_record_user_id || "",
			evidence_type: requiredEvidence?.evidence_type || data?.evidence_type || submarking?.evidence_type || newSubmarking?.evidence_type,
			parties: requiredEvidence?.parties || data?.parties || submarking?.parties || newSubmarking?.parties,
			status: data?.status || submarking?.status || "",
			witness_name: data?.witness_name || submarking?.witness_name,
			exhibit: data?.exhibit || submarking?.exhibit,
			description: selectedText || data?.description || submarking?.description,
			purpose: data?.purpose || submarking?.purpose || "",
			stenography: data?.stenography,
			evidence: file ? file : null,
			category: data?.category,
		},
	});
	console.log(data?.category, "category");
	console.log(form.getValues("category"), "category watch");

	const storedTime = sessionStorage.getItem("password_entered_at");

	const handleSubmit = async (values: CaseEvidenceForm) => {
		const expirationTime = moment(storedTime).add(5, "minutes");
		if (storedTime && expirationTime !== undefined && moment().isBefore(expirationTime)) {
			await caseEvidenceMutation.mutateAsync(values);
			closeModal();
		} else {
			try {
				modal.openModal({
					allowClose: true,
					title: "Confirm Submit",
					description: "Are you sure? This action cannot be undone.",
					size: "sm",
					showHeader: true,
					showFooter: false,
					component: (
						<ConfirmWithPasswordModal
							onSubmit={async () => {
								await caseEvidenceMutation.mutateAsync(values);
							}}
						/>
					),
				});
				closeModal();
			} catch (error) {
				console.log(error);
			}
		}
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(onSubmit ? onSubmit : handleSubmit)}>
				<div className="flex flex-col w-full gap-4">
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="category"
							render={() => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel>Category</FormLabel>
									</div>
									<FormGroup>
										<FormField
											control={form.control}
											name="category"
											render={({ field }) => (
												<ComboboxCreatable
													isMulti={true}
													defaultValue={field.value}
													onValueChange={async (value) => {
														field.onChange(value);
													}}
													loadOptions={async (value: string) => {
														const items = await caseEvidenceCategoryService.listAllEvidenceCategories(data?.case_id, {
															"filter[case_id]": data?.case_id,
														});
														return items?.map((e: string) => {
															return {
																label: e,
																value: e,
															};
														});
													}}
												/>
											)}
										/>
									</FormGroup>
								</FormItem>
							)}
						/>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-4">
					<Button variant="ghost" type="button" onClick={closeModal}>
						Cancel
					</Button>
					<Button type="submit" loading={form.formState.isSubmitting}>
						{data?.id || submarking?.id ? "Update" : "Submit"}
					</Button>
				</div>
			</form>
		</Form>
	);
}
